import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'

export function deleteEvent(
  eventUuid: string
): Promise<AxiosResponse<unknown>> {
  return instance.delete(`/event/${eventUuid}`)
}
